import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "scheduled-task",
  "use": "scheduled-task-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"scheduled-task\"><path fill-rule=\"evenodd\" d=\"M18 4V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1Zm1 16H5V9h14M9.68 19.492l5.428-5.144-2.171-.79 1.474-4.05-5.518 5.11 2.26.823-1.473 4.051Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol